/* intercept fetch: */
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let cart_changed = false;
  if (resource === "/cart/change.js") {
    cart_changed = true;
  }

  let response = await originalFetch(resource, config);

  if (cart_changed) {
    document.dispatchEvent(new Event("cartUpdated"));
  }

  // response interceptor
  const json = () =>
    response
      .clone()
      .json()
      .then((data) => ({ ...data, title: `Intercepted: ${data.title}` }));

  response.json = json;
  return response;
};
